// Simple hook to manage an internal navigation hash flag across routes
// It standardizes using '#from=internal' and helps generate links preserving the hash
import { useMemo } from 'react';

const INTERNAL_HASH = 'from=internal';

export function useFromHash() {
    const currentHash = typeof window !== 'undefined' ? (window.location?.hash || '').replace('#', '') : '';
    const hasInternalFrom = currentHash.includes(INTERNAL_HASH);

    const buildPathWithFrom = useMemo(() => {
        return (basePath) => {
            if (!basePath) return basePath;
            return hasInternalFrom ? `${basePath}#${INTERNAL_HASH}` : `${basePath}#${INTERNAL_HASH}`;
        };
    }, [hasInternalFrom]);

    const ensureFromInternalHash = useMemo(() => {
        return (basePath) => `${basePath}#${INTERNAL_HASH}`;
    }, []);

    const getInternalLinkProps = useMemo(() => {
        return (basePath) => ({ to: ensureFromInternalHash(basePath), state: { from: 'internal' } });
    }, [ensureFromInternalHash]);

    return {
        isFromInternal: hasInternalFrom,
        buildPathWithFrom,
        ensureFromInternalHash,
        INTERNAL_HASH,
        getInternalLinkProps,
    };
}

export default useFromHash;
